import { createContext, useContext, useEffect, useState } from "react";

const BrandContext = createContext(null);

export function BrandProvider({ children }) {
  const [accent, setAccent] = useState(null);

  useEffect(() => {
    document.documentElement.style.setProperty("--brand-color", accent || "#4A5568");
    return () => document.documentElement.style.setProperty("--brand-color", "#4A5568");
  }, [accent]);

  return <BrandContext.Provider value={{ accent, setAccent }}>{children}</BrandContext.Provider>;
}

export const useBrandAccent = () => useContext(BrandContext);
